import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function lazyLoadView (AsyncView) {
	const AsyncHandler = () => ({
		component: AsyncView,
		// A component to use while the component is loading.
		loading: null,
		// Delay before showing the loading component.
		// Default: 200 (milliseconds).
		delay: 400,
		// A fallback component in case the timeout is exceeded
		// when loading the component.
		error: null,
		// Time before giving up trying to load the component.
		// Default: Infinity (milliseconds).
		timeout: 10000
	  })

	  return Promise.resolve({
		functional: true,
		render (h, { data, children }) {
		  // Transparently pass any props or children
		  // to the view component.
		  return h(AsyncHandler, data, children)
		}
	})
}

export default new Router({
	mode: 'history',
	base: '/',
	linkActiveClass: 'active',
	linkExactActiveClass: 'active-route',
	fallback: true,
	routes: [

		{
			path: '/tourReservation',
			name: 'app.user.operation.tour',
			meta: {
				auth: true,
				layout: 'user-layout',
				permission: {
					name: 'operation.tour',
					actions: [
					  'visit'
					]
				  },
				breadcrumb: [
					{ name: 'operation' },
					{ name: 'tour' }
				]
			},
			component: () => lazyLoadView(import('@/components/app/user/operation/tour')),
			children: [

				{
					path: 'tourSales',
					name: 'app.user.operation.tour.toursales',
					meta: {
						auth: true,
						layout: 'user-layout',
						permission: {
							name: 'operation.tour.sale',
							actions: [
							  'visit'
							]
						  },
						breadcrumb: [
							{ name: 'operation' },
							{ name: 'tour' },
							{ name: 'toursales' }
						]
					},
					component: () => lazyLoadView(import('@/components/app/user/operation/tour/tour-sale'))
				},
				{
					path: 'sales/create',
					name: 'app.user.operation.tour.sales.create',
					meta: {
						auth: true,
						layout: 'user-layout',
						permission: {
							name: 'operation.tour.sale',
							actions: [
							  'create'
							]
						  },
						breadcrumb: [
							{ name: 'operation' },
							{ name: 'tour' },
							{ name: 'sales' }
						],
						title: 'Semerşah Europe',
						favicon: '/static/Favicons/semersah_europe.ico'
					},
					component: () => lazyLoadView(import('@/components/app/user/operation/tour/sale/sale-create'))
				},
				{
					path: 'sales/create2',
					name: 'app.user.operation.tour.sales.create2',
					meta: {
						auth: true,
						layout: 'user-layout',
						permission: {
							name: 'operation.tour.sale',
							actions: [
							  'create'
							]
						  },
						breadcrumb: [
							{ name: 'operation' },
							{ name: 'tour' },
							{ name: 'sales' }
						],
						title: 'DITIB'
					},
					component: () => lazyLoadView(import('@/components/app/user/operation/tour/sale/sale-create2'))
				}
			]
		},
		{
			path: '/403',
			name: 'auth.forbidden',
			meta: {
				auth: undefined,
				layout: 'auth-layout'
			},
			component: () => lazyLoadView(import('@/components/common/errors/Forbidden'))
		},
		{
			path: '/404',
			name: 'auth.notfound',
			meta: {
				auth: undefined,
				layout: 'auth-layout'
			},
			component: () => lazyLoadView(import('@/components/common/errors/NotFound'))
		},
		{
			path: '*',
			name: 'unknown',
			redirect: '/404'
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js